
import React, { useState } from 'react';
import { ItineraryEvent } from '@/types/itinerary';
import TravelSchedule from '@/components/travel/TravelSchedule';
import AddTransportationDialog from '@/components/travel/AddTransportationDialog';
import { useTransportation } from '@/hooks/travel/useTransportation';

interface TravelTabProps {
  transportationEvents: ItineraryEvent[];
  selectedDate: string; 
  isLoading: boolean;
  error: string | null;
  canEdit: boolean;
  onRefresh: () => void;
  onRetry: () => void;
  onAddTransportation?: () => void;
}

const TravelTab: React.FC<TravelTabProps> = ({
  transportationEvents,
  selectedDate,
  isLoading,
  error,
  canEdit,
  onRefresh,
  onRetry,
  onAddTransportation
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  
  // Filter events for selected date if we have a selected date
  // Otherwise show all transportation events
  // We don't filter by user here - we show ALL transportation events for all users
  const filteredEvents = selectedDate 
    ? transportationEvents.filter(event => event.date === selectedDate)
    : transportationEvents;

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    onRefresh(); // Refresh the list after dialog closes
  };

  return (
    <div>
      <p className="text-sm text-muted-foreground mb-4">
        Showing all transportation for all trip members
      </p>
      <TravelSchedule
        transportationEvents={filteredEvents}
        isLoading={isLoading}
        error={error}
        isAuthorized={canEdit}
        onRefresh={onRefresh}
        onRetry={onRetry}
        onAddTransportation={canEdit ? handleOpenDialog : undefined}
        forSelectedDate={!!selectedDate}
      />
      
      {/* This empty fragment is here to handle the case where onAddTransportation might not be provided */}
      {canEdit && onAddTransportation ? (
        <AddTransportationDialog
          open={isDialogOpen}
          onClose={handleCloseDialog}
          outboundDetails={{ 
            type: 'flight',
            departure: '',
            arrival: '',
            departureDate: null,
            departureTime: '',
            notes: '',
            confirmation: '',
            userName: ''
          }}
          returnDetails={{
            type: 'flight',
            departure: '',
            arrival: '',
            departureDate: null,
            departureTime: '',
            notes: '',
            confirmation: '',
            userName: ''
          }}
          onOutboundChange={() => {}}
          onReturnChange={() => {}}
          onSaveOutbound={() => {}}
          onSaveReturn={() => {}}
        />
      ) : null}
    </div>
  );
};

export default TravelTab;
